// Türkçe uyumlu arama metni normalizasyonu.
// "BİROL".toLowerCase() → "bi̇rol" (i + birleşik nokta U+0307) olduğu için düz
// toLowerCase + includes ile "bir" araması eşleşmiyordu. Burada harfler tek
// biçime indirgenir: İ/I/ı/i → i, Ş → s, Ğ → g, Ü → u, Ö → o, Ç → c.
export const normalizeSearchText = (value) =>
  String(value ?? '')
    .replace(/[İIı]/g, 'i')
    .toLowerCase()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

// Arama terimi alanlardan herhangi birinde geçiyorsa true. Boş terim her şeyi eşler.
export const matchesSearch = (term, ...fields) => {
  const q = normalizeSearchText(term);
  if (!q) return true;
  return fields.some((field) => normalizeSearchText(field).includes(q));
};
